// extracted by mini-css-extract-plugin
export default {"container":"iq-z","ratingLayout":"jq-z","ratingLabel":"kq-z","nonInteractiveRatingLabel":"lq-z"};